/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendLeasingContractVariantDto } from '../../models/backend-leasing-contract-variant-dto';
import { BackendPatchedLeasingContractVariantRequestDto } from '../../models/backend-patched-leasing-contract-variant-request-dto';

export interface FinancingSourcesLeasingsVariantsPartialUpdate$XWwwFormUrlencoded$Params {
  /**
   * A unique integer value identifying this leasing contract variant.
   */
  id: number;
  body?: BackendPatchedLeasingContractVariantRequestDto;
}

export function financingSourcesLeasingsVariantsPartialUpdate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesLeasingsVariantsPartialUpdate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendLeasingContractVariantDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    financingSourcesLeasingsVariantsPartialUpdate$XWwwFormUrlencoded.PATH,
    'patch',
  );
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendLeasingContractVariantDto>;
    }),
  );
}

financingSourcesLeasingsVariantsPartialUpdate$XWwwFormUrlencoded.PATH =
  '/api/financing_sources/leasings_variants/{id}/';
